import { render } from "./PasswordPage.vue?vue&type=template&id=df1ef346&ts=true"
import script from "./PasswordPage.vue?vue&type=script&lang=ts"
export * from "./PasswordPage.vue?vue&type=script&lang=ts"

import "./PasswordPage.vue?vue&type=style&index=0&id=df1ef346&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/DangKyKB_HV/DKKB_new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__